'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../../../node_modules/@radix-ui/react-switch/dist/index.cjs');
var Typography_web = require('../../atoms/Typography/Typography.web.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var InternalToggle_web_styles = require('./InternalToggle.web.styles.cjs');

// TODO: Add Supernova documentation link
/**
 * A UI control that allows users to toggle a single setting on or off
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/internal/InternalToggle/InternalToggle.web.tsx | View in GitLab}
 *
 * @scope Core, Internal
 */ const InternalToggle = ({ id, isChecked = false, disabled = false, label, icon, customCss, "data-testid": dataTestId, "data-appcuesid": dataAppcuesId, "data-e2e": dataE2e, ...props })=>{
    const theme = react.useTheme();
    const wrapperStyles = [
        InternalToggle_web_styles.toggleWrapper,
        customCss
    ];
    const ariaLabel = props["aria-label"] || label;
    const renderLabel = ()=>{
        if (!label) return null;
        return /*#__PURE__*/ jsxRuntime.jsx("label", {
            htmlFor: id,
            "data-testid": "aviary-toggle-label",
            children: /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                as: "span",
                variant: "callout",
                customCss: InternalToggle_web_styles.toggleLabel(theme, disabled),
                children: label
            })
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        css: wrapperStyles,
        "data-disabled": disabled,
        "data-testid": dataTestId || "aviary-internal-toggle",
        "data-appcuesid": dataAppcuesId,
        "data-e2e": dataE2e,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(index.Root, {
                id: id,
                checked: isChecked,
                disabled: disabled,
                css: InternalToggle_web_styles.track(theme, isChecked),
                "aria-label": ariaLabel,
                ...props,
                children: /*#__PURE__*/ jsxRuntime.jsx(index.Thumb, {
                    css: InternalToggle_web_styles.toggleButton,
                    "data-testid": "aviary-toggle-button",
                    children: icon && /*#__PURE__*/ jsxRuntime.jsx("div", {
                        css: InternalToggle_web_styles.iconWrapper,
                        "data-testid": "aviary-toggle-icon",
                        children: /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                            icon: icon,
                            css: InternalToggle_web_styles.icon
                        })
                    })
                })
            }),
            renderLabel()
        ]
    });
};
InternalToggle.displayName = "InternalToggle";

exports.InternalToggle = InternalToggle;
//# sourceMappingURL=InternalToggle.web.cjs.map
